import React from 'react'
import { useState, useEffect, useCallback } from "react";
import Notification from "../components/Notification";
import { getAllBranch, getBranches, getPackages, getTimeSlots, createPackageApi, getHappyHours, updatePackageApi } from "../api/reusableApis";
import {
    FiPlus,
    FiSearch
} from "react-icons/fi";
import Modal from "../components/modal";
import TimePickerField from '../components/TimePickerField';

import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Imagelist from '../components/Imagelist';
import Cards from '../components/Cards';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const Packages = () => {

    const [loader, setLoader] = useState(true);
    const [toast, setToast] = useState({ message: "", type: "success" });
    const [search, setSearch] = useState("");
    const [branch, setBranch] = useState([]);
    const [timeSlots, setTimeSlots] = useState([]);
    const [value, setValue] = useState([]);  // this is for timeslots
    const [day, setDay] = useState([]);  // this is for happyhours
    const [selectedBranch, setSelectedBranch] = useState('');
    const [packages, setPackages] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [mode, setMode] = useState("create");
    const [formData, setFormData] = useState({
        name: "",
        code: "",
        description: "",
        advance_amount: 0,
        package_time_slots: [],
        branch_prices: [],
        happy_hours: {
            start_time: "",
            end_time: "",
            override_price: 0,
            is_active: false
        }
    });
    const [dayOfWeek, setDayOfWeek] = useState([]);
    const [deletedImages, setDeletedImages] = useState([]);
    const [errors, setErrors] = useState({});
    const [images, setImages] = useState([]);
    const [packageId, setPackageId] = useState("");

    const MAX_IMAGES = 5;

    const createPackages = () => {
        setOpenModal(true);
        setValue([]);
        setMode("create");
        setFormData({
            name: "",
            code: "",
            description: "",
            advance_amount: 0,
            package_time_slots: [],
            branch_prices: [],
            happy_hours: {
                start_time: "",
                end_time: "",
                override_price: 0,
                is_active: false
            }
        });
    }


    function onBranchSelected(branch_id) {
        setSelectedBranch(branch_id);
        fetchAllPackages(branch_id);
    }

    const fetchAllPackages = useCallback(async (selectedBranch) => {
        try {
            setLoader(true);
            console.log(selectedBranch, 'selectedBranch');
            const packages = await getPackages(selectedBranch);
            setPackages(packages);
            setLoader(false);
            console.log(packages, 'packages');
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }, []);

    const closeModal = () => {
        setOpenModal(false);
        setMode("create");
        setFormData({
            name: "",
            code: "",
            description: "",
            advance_amount: 0,
            package_time_slots: [],
            branch_prices: [],
            happy_hours: {
                start_time: "",
                end_time: "",
                override_price: 0,
                is_active: false
            }
        });
        setImages([]);
    };

    const handleEditPackage = async (theme) => {
        console.log(theme, 'theme');
        var package_id = theme['ROWID'];
        setPackageId(package_id);
        setOpenModal(true);
        setMode('edit');
        var getHappyHoursDetails = await getHappyHours(package_id, true);
        console.log(getHappyHoursDetails, 'getHappyHoursDetails');
        const selectedDays =
            dayOfWeek.filter(d =>
                getHappyHoursDetails?.[0]?.dayOfWeek?.includes(d.key)
            );

        const selectedTimeSlots =
            timeSlots.filter(ts =>
                theme.time_slots.some(p => p.time_slot_id === ts.ROWID)
            );

        let obj = {
            name: theme['name'],
            code: theme['code'],
            description: theme['description'],
            advance_amount: theme['advance_amount'],
            package_time_slots: theme?.time_slots,
            branch_prices: [{
                branch_id: theme['branch_id'],
                is_active: theme['is_active'],
                price: parseInt(theme['price'])
            }],
            happy_hours: {
                start_time: getHappyHoursDetails?.[0]?.['start_time'] || '',
                end_time: getHappyHoursDetails?.[0]?.['end_time'] || '',
                override_price: getHappyHoursDetails?.[0]?.['override_price'] || 0,
                is_active: getHappyHoursDetails?.[0]?.['is_active'] || false,
                dayOfWeek: getHappyHoursDetails?.[0]?.['dayOfWeek'] || []
            }
        }
        console.log(obj);
        setFormData(obj);


        setValue(selectedTimeSlots);
        setDay(selectedDays);
        setImages(theme['images']);
    }

    const filteredpackages = packages.filter((pack) => {

        return pack.name.toLowerCase().includes(search.toLowerCase()) ||
            pack.description.toLowerCase().includes(search.toLowerCase())
    }
    );

    const fetchBranch = useCallback(async () => {
        try {
            setLoader(true);
            const branches = await getBranches(true);
            setBranch(branches);
            setLoader(false);
            console.log(branches, 'branches');
            if (branches && branches.length > 0) {
                const firstBranchId = branches[0]['ROWID'];
                setSelectedBranch(firstBranchId);
                fetchAllPackages(firstBranchId);
            }
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }, [fetchAllPackages]);


    const fetchTimeSlots = useCallback(async () => {
        try {
            setLoader(true);
            const timeSlots = await getTimeSlots();
            setTimeSlots(timeSlots);
            setLoader(false);
            console.log(timeSlots, 'time_slots');
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }, []);


    useEffect(() => {
        fetchBranch();
        fetchTimeSlots();

        var dayOfWeek = [
            {
                "key": "Monday",
                "value": "Monday"
            },
            {
                "key": "Tuesday",
                "value": "Tuesday"
            },
            {
                "key": "Wednesday",
                "value": "Wednesday"
            },
            {
                "key": "Thursday",
                "value": "Thursday"
            },
            {
                "key": "Friday",
                "value": "Friday"
            },
            {
                "key": "Saturday",
                "value": "Saturday"
            },
            {
                "key": "Sunday",
                "value": "Sunday"
            }
        ]
        setDayOfWeek(dayOfWeek);
    }, []);

    useEffect(() => {
        console.log(formData, 'updatedFormData');
    }, [formData])

    useEffect(() => {
        console.log(deletedImages, 'deletedImages');
    }, [deletedImages])

    useEffect(() => {
        console.log(value);
        var timeSlots = [];
        value.forEach(time => {
            let obj = {
                "time_slot_id": time['ROWID']
            }
            timeSlots.push(obj);
        });
        setFormData((prev) => ({ ...prev, package_time_slots: timeSlots }));
    }, [value]);

    useEffect(() => {
        console.log(day);
        var dayofweek = [];
        day.forEach(day => {
            dayofweek.push(day['key']);
        });

        setFormData((prev) => ({
            ...prev,
            happy_hours: {
                ...prev.happy_hours,
                dayOfWeek: dayofweek
            },
        }));
    }, [day]);

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;
        const imagesData = files.map((file) => ({
            image: file,
            url: URL.createObjectURL(file),
            ROWID: "",
        }));
        setImages((prev) => [...prev, ...imagesData]);
    };


    const handleDeleteImage = (imageToDelete) => {
        if (mode === 'edit') {
            console.log(imageToDelete, 'image');
            if (imageToDelete['ROWID'].trim().length === 0) {
                setImages((prev) =>
                    prev.filter((img) => img.url !== imageToDelete.url)
                );
            } else if (imageToDelete['ROWID'].trim().length > 0) {
                setDeletedImages((prev) => [...prev, imageToDelete['ROWID']]);
                setImages((prev) =>
                    prev.filter((img) => img.url !== imageToDelete.url)
                );
            }
        } else if (mode === 'create') {
            setImages((prev) =>
                prev.filter((img) => img.url !== imageToDelete.url)
            );
        }
    };



    const updatePackages = async () => {
        if (mode === "create") {
            if (formData.name.trim().length === 0) {
                setToast({
                    message: "Package Name is required.",
                    type: "error",
                });
                return;
            }
            if (formData.description.length === 0) {
                setToast({
                    message: "Package description is required.",
                    type: "error",
                });
                return;
            }
            if (formData.advance_amount === 0) {
                setToast({
                    message: "Package advance amount is required.",
                    type: "error",
                });
                return;
            }
            if (formData.description.length === 0) {
                setToast({
                    message: "Package description is required.",
                    type: "error",
                });
                return;
            }
            if (formData.branch_prices.length === 0) {
                setToast({
                    message: "Branch Wise Pricing is required.",
                    type: "error",
                });
                return;
            }
            if (formData.package_time_slots.length === 0) {
                setToast({
                    message: "Package Time-Slot is required.",
                    type: "error",
                });
                return;
            }
            if (formData.happy_hours.is_active === true && (formData.happy_hours.start_time.trim().length === 0 || formData.happy_hours.end_time.trim().length === 0 || formData.happy_hours.override_price === 0 || formData.happy_hours.dayOfWeek.length === 0)) {
                setToast({
                    message: "All fields are required in Happy hours",
                    type: "error",
                });
                return;
            }

            let formDatas = new FormData();
            if (images && images.length > 0) {
                images.forEach(img => {
                    formDatas.append('package_images', img.image);
                })
            }
            let requestObj = {};
            requestObj.description = formData.description;
            requestObj.name = formData.name;
            requestObj.code = formData.code;
            requestObj.advance_amount = parseInt(formData.advance_amount);

            if (formData.branch_prices.length > 0) {
                requestObj.branch_prices = formData.branch_prices;
            }
            if (formData.package_time_slots.length > 0) {
                requestObj.package_time_slots = formData.package_time_slots;
            }
            if (Object.keys(formData.happy_hours).length > 0 && formData.happy_hours.start_time.length > 0 && formData.happy_hours.dayOfWeek.length > 0) {
                requestObj.happy_hours = formData.happy_hours;
            }

            formDatas.append('json', JSON.stringify(requestObj));

            try {
                const response = await createPackageApi(formDatas);
                console.log('created:', response.data);
                if (response.data.success === true) {
                    setToast({
                        message: response.data.message || "Package details created successfully",
                        type: "success",
                    });
                } else if (response.data.success === false) {
                    setToast({
                        message: response.data?.message || "Failed to create the package",
                        type: "error",
                    });
                }
                closeModal();
            } catch (error) {
                console.error('Update failed:', error);
                setToast({
                    message: error?.message || "Something Went Wrong.!",
                    type: "error",
                });
            }

        } else if (mode === "edit") {
            if (formData.name.trim().length === 0) {
                setToast({
                    message: "Package Name is required.",
                    type: "error",
                });
                return;
            }
            if (formData.description.length === 0) {
                setToast({
                    message: "Package description is required.",
                    type: "error",
                });
                return;
            }
            if (formData.advance_amount === 0) {
                setToast({
                    message: "Package advance amount is required.",
                    type: "error",
                });
                return;
            }
            if (formData.description.length === 0) {
                setToast({
                    message: "Package description is required.",
                    type: "error",
                });
                return;
            }
            if (formData.branch_prices.length === 0) {
                setToast({
                    message: "Branch Wise Pricing is required.",
                    type: "error",
                });
                return;
            }
            if (formData.package_time_slots.length === 0) {
                setToast({
                    message: "Package Time-Slot is required.",
                    type: "error",
                });
                return;
            }
            if (formData.happy_hours.is_active === true && (formData.happy_hours.start_time.trim().length === 0 || formData.happy_hours.end_time.trim().length === 0 || formData.happy_hours.override_price === 0 || formData.happy_hours.dayOfWeek.length === 0)) {
                setToast({
                    message: "All fields are required in Happy hours",
                    type: "error",
                });
                return;
            }

            let formDatas = new FormData();
            if (images && images.length > 0) {
                images.forEach(img => {
                    if (img.ROWID === "" && img.ROWID.trim().length === 0) {
                        if (img.image) {
                            formDatas.append('package_images', img.image);
                        }
                    }
                })
            }


            let requestObj = {};
            requestObj.description = formData.description;
            requestObj.name = formData.name;
            requestObj.advance_amount = parseInt(formData.advance_amount);

            if (formData.branch_prices.length > 0) {
                requestObj.branch_prices = formData.branch_prices;
            }
            if (formData.package_time_slots.length > 0) {
                requestObj.package_time_slots = formData.package_time_slots;
            }
            if (Object.keys(formData.happy_hours).length > 0 && formData.happy_hours.start_time.length > 0 && formData.happy_hours.dayOfWeek.length > 0) {
                requestObj.happy_hours = formData.happy_hours;
            }

            if (deletedImages.length === 0) {
                requestObj.delete_image_ids = [];
            } else if (deletedImages.length > 0) {
                requestObj.delete_image_ids = deletedImages;
            }

            formDatas.append('json', JSON.stringify(requestObj));

            try {
                const response = await updatePackageApi(formDatas, packageId);
                console.log('updated:', response.data);
                if (response.data.success === true) {
                    setToast({
                        message: response.data.message || "Package details updated successfully",
                        type: "success",
                    });
                } else if (response.data.success === false) {
                    setToast({
                        message: response.data?.message || "Failed to create the Package",
                        type: "error",
                    });
                }
                closeModal();
            } catch (error) {
                console.error('Update failed:', error);
                setToast({
                    message: error?.message || "Something Went Wrong.!",
                    type: "error",
                });
            }

        }
    }

    const generateCode = (packageName) => {
        if (mode === 'create') {
            const cleanName = packageName
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, "") // remove special chars
                .slice(0, 10); // limit length

            const randomPart = Math.random()
                .toString(36)
                .substring(2, 6)
                .toUpperCase();

            var name = `PKG-${cleanName}-${randomPart}`;
            setFormData((p) => ({ ...p, code: name }));
        }
    }

    useEffect(() => {
        return () => {
            images.forEach(item => URL.revokeObjectURL(item.url));
        };
    }, [images]);

    return (
        <>
            {loader ? (
                <div className="flex items-center justify-center min-h-[60vh] w-full">
                    <div className="w-8 h-8 border-4 border-gray-300 border-t-[#72398E] rounded-full animate-spin"></div>
                </div>
            )
                :
                <>
                    <Notification
                        message={toast.message}
                        type={toast.type}
                        onClose={() => setToast({ message: "", type: "success" })}
                    />

                    <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen h-screen overflow-y-auto">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
                            <div>
                                <h1 className="text-3xl font-bold tracking-tight text-[#72398E]">Package's</h1>
                                <p className="text-sm text-slate-500 mt-2">
                                    Manage event packages and themes by configuring designs, pricing, and included services to offer curated celebration experiences.
                                </p>
                            </div>

                            <div className="flex gap-3 w-full sm:w-auto">
                                <button
                                    onClick={() => createPackages()}
                                    className="flex items-center gap-2 text-white px-5 py-2 rounded-xl shadow-md transition bg-[#72398E]"
                                >
                                    <FiPlus /> Theme's
                                </button>
                            </div>
                        </div>

                        <div className="bg-white rounded-xl border border-slate-200 p-4 flex flex-col sm:flex-row gap-4 mb-6">
                            <div className="flex items-center gap-2 border border-slate-300 rounded-xl px-4 py-2 flex-1 bg-slate-50 focus-within:ring-2 focus-within:ring-slate-900">
                                <FiSearch className="text-slate-400" />
                                <input
                                    placeholder="Search Package names"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="bg-transparent outline-none text-sm w-full"
                                />
                            </div>

                            <select
                                value={selectedBranch}
                                onChange={(e) => onBranchSelected(e.target.value)}
                                className="h-10 px-4 rounded-xl border border-slate-300 bg-slate-50 text-sm"
                            >
                                {branch.map((r) => (
                                    <option key={r.ROWID} value={r.ROWID}>{r.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className='mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 items-start'>
                            {filteredpackages && filteredpackages.map((pack) => {
                                return (
                                    <Cards key={pack.ROWID} packages={pack} branches={branch}
                                        onEdit={() => handleEditPackage(pack)} />
                                )
                            })
                            }
                        </div>
                    </div>

                    <Modal
                        open={openModal}
                        onClose={closeModal}
                        title={
                            mode === "view"
                                ? "View Theme's"
                                : mode === "edit"
                                    ? "Edit Theme's"
                                    : "Create Theme's"
                        }
                        width="w-full sm:w-[95%] md:max-w-2xl" // Increased width for better 2-column layout
                    >
                        <div className="space-y-8 p-1">
                            <Notification
                                message={toast.message}
                                type={toast.type}
                                onClose={() => setToast({ message: "", type: "success" })}
                            />
                            {(mode === "create" || mode === "edit" || mode === 'view') && (
                                <div className="mb-8 flex flex-col items-center sm:flex-row gap-6 p-5 rounded-2xl bg-slate-50 border border-dashed border-slate-200">
                                    {images && images.length === 0 ?
                                        <div className="relative group">
                                            <div className="h-24 w-24 rounded-2xl overflow-hidden bg-slate-200 ring-4 ring-white shadow-md">
                                                <div className="h-full w-full flex items-center justify-center text-slate-400 text-xs text-center p-2 font-medium">
                                                    Images
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <Imagelist images={images} onDeleteImage={handleDeleteImage} />
                                    }

                                    <div className="flex-1 text-center sm:text-left">
                                        <h4 className="text-sm font-bold text-slate-700">Theme's Identity</h4>
                                        <p className="text-xs text-slate-500 mb-3">Upload a high-quality logo (PNG, JPG)</p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            onChange={handleImageUpload}
                                            className="hidden"
                                            id="logo-upload"
                                            disabled={mode === 'view'}
                                        />
                                        <label
                                            htmlFor="logo-upload"
                                            className="inline-block px-4 py-2 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-600 cursor-pointer hover:border-purple-500 hover:text-purple-600 transition-all shadow-sm"
                                        >
                                            Choose Image
                                        </label>

                                        {errors.image && (
                                            <div className="text-[11px] text-rose-500 mt-2 font-medium">
                                                {errors.image}
                                            </div>
                                        )}
                                    </div>

                                </div>
                            )}

                            {/* --- Section 1: Basic Information --- */}
                            <div>
                                <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                    <span className="w-8 h-[1px] bg-slate-200"></span> Package Details
                                </h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                                    <FormInput
                                        label="Package Name"
                                        value={formData.name}
                                        onChange={(val) => {
                                            setFormData((p) => ({ ...p, name: val }));
                                            setErrors((prev) => ({ ...prev, name: null }));
                                            generateCode(val);
                                        }}
                                        placeholder="Package Name"
                                        disabled={mode === "view"}
                                        error={errors.name}
                                    />

                                    <FormInput
                                        label="Package Code"
                                        value={formData.code}
                                        onChange={(val) => {
                                            setFormData((p) => ({ ...p, code: val }));
                                            setErrors((prev) => ({ ...prev, code: null }));
                                        }}
                                        placeholder="Code"
                                        disabled={true}
                                        error={errors.code}
                                    />
                                </div>
                                <div className="mt-5">
                                    <FormInput
                                        label="Advance Amount"
                                        value={formData.advance_amount}
                                        onChange={(val) => {
                                            setFormData((p) => ({ ...p, advance_amount: val }));
                                            setErrors((prev) => ({ ...prev, advance_amount: null }));
                                        }}
                                        placeholder="Advance Amount"
                                        disabled={mode === "view"}
                                        error={errors.advance_amount}
                                    />
                                </div>

                                <div className="mt-5">
                                    <FormTextareaInput
                                        label="Description"
                                        value={formData.description}
                                        onChange={(val) => {
                                            setFormData((p) => ({ ...p, description: val }));
                                            setErrors((prev) => ({ ...prev, description: null }));
                                        }}
                                        placeholder="Description"
                                        disabled={mode === "view"}
                                        error={errors.description}
                                    />
                                </div>
                            </div>

                            <div>
                                <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                    <span className="w-8 h-[1px] bg-slate-200"></span> Time-slot Details
                                </h3>
                                <Autocomplete
                                    multiple
                                    id="checkboxes-tags-demo"
                                    value={value}
                                    onChange={(event, newValue) => {
                                        setValue(newValue);
                                    }}
                                    options={timeSlots}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.label}
                                    renderOption={(props, option, { selected }) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                            <li key={key} {...optionProps}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.label}
                                            </li>
                                        );
                                    }}
                                    sx={{ width: '100%' }}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField {...params} label="Time slot's" placeholder="Time-slot's" sx={{
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '12px',
                                                opacity: 0.8,
                                                color: 'rgba(0,0,0,0.6)',
                                                borderRadius: '10px'
                                            }
                                        }} />
                                    )}
                                />
                            </div>

                            <div>
                                <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                    <span className="w-8 h-[1px] bg-slate-200"></span> Branch wise Pricing
                                </h3>

                                <div className="space-y-4 max-h-96 overflow-y-auto">
                                    {formData.branch_prices?.map((branchPrice, index) => (
                                        <div key={index}>
                                            <div className="flex items-end gap-4 p-4 bg-slate-50 rounded-xl group hover:bg-slate-100 transition-all">
                                                {/* Branch Dropdown */}
                                                <div className="flex-1">
                                                    <label className="block text-xs font-semibold text-slate-600 mb-1">
                                                        Branch
                                                    </label>
                                                    <select
                                                        value={branchPrice.branch_id || ''}
                                                        onChange={(e) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                branch_prices: prev.branch_prices.map((b, i) =>
                                                                    i === index ? { ...b, branch_id: e.target.value } : b
                                                                )
                                                            }));
                                                        }}
                                                        className="w-full px-3 py-2 border border-slate-200 rounded-lg bg-white text-sm"
                                                        disabled={mode === "view"} //mode === "edit"
                                                    >
                                                        <option value="">Select Branch</option>
                                                        {branch
                                                            .filter(b =>
                                                                !formData.branch_prices.some((existing, i) =>
                                                                    existing.branch_id === b.ROWID && i !== index
                                                                )
                                                            )
                                                            .map(b => (
                                                                <option key={b.ROWID} value={b.ROWID}>{b.name}</option>
                                                            ))}
                                                    </select>
                                                </div>

                                                {/* Price Input */}
                                                <div className="flex-1">
                                                    <label className="block text-xs font-semibold text-slate-600 mb-1">
                                                        Price (₹)
                                                    </label>
                                                    <input
                                                        type="number"
                                                        value={branchPrice.price || ''}
                                                        onChange={(e) => {
                                                            const price = e.target.value;
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                branch_prices: prev.branch_prices.map((b, i) =>
                                                                    i === index ? { ...b, price } : b
                                                                )
                                                            }));
                                                        }}
                                                        placeholder="0"
                                                        min="0"
                                                        className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                        disabled={mode === "view"}
                                                    />
                                                </div>

                                                {/* Remove Row */}
                                                {formData.branch_prices.length > 1 && mode !== "view" && (
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                branch_prices: prev.branch_prices.filter((_, i) => i !== index)
                                                            }));
                                                        }}
                                                        className="p-2 -m-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all group-hover:opacity-100 opacity-0"
                                                        title="Remove"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>

                                            <div className="flex items-center justify-between p-5 mt-5 rounded-2xl bg-slate-50 border border-slate-100 transition-all hover:bg-slate-100/50">
                                                <div>
                                                    <p className="text-sm font-bold text-slate-700">Active Status</p>
                                                    <p className="text-xs text-slate-500">Visible to customers and staff</p>
                                                </div>
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={branchPrice.is_active ?? true}  // ✅ Default false
                                                        onChange={(e) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                branch_prices: prev.branch_prices.map((branch, i) =>
                                                                    i === index
                                                                        ? { ...branch, is_active: e.target.checked }
                                                                        : branch
                                                                )
                                                            }));
                                                        }}
                                                        className="sr-only peer"
                                                        disabled={mode === "view"}
                                                    />
                                                    <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                                                </label>
                                            </div>
                                        </div>
                                    )) || (
                                            <div className="text-center py-8 text-gray-500">
                                                No branches selected
                                            </div>
                                        )}
                                </div>


                                {/* mode !== "view" && mode !== "edit" */}
                                {/* Add Branch Row Button */}
                                {mode !== "view" && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setFormData(prev => ({
                                                ...prev,
                                                branch_prices: [...(prev.branch_prices || []), { branch_id: '', price: '', is_active: true }]
                                            }));
                                        }}
                                        className="w-full flex items-center justify-center gap-2 px-4 py-3 mt-4 border-2 border-dashed border-slate-300 rounded-xl hover:border-blue-400 hover:bg-blue-50 transition-all text-sm font-medium text-slate-600 hover:text-blue-600"
                                    >
                                        ➕ Add Branch Price
                                    </button>
                                )}

                            </div>

                            <div>
                                <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                    <span className="w-8 h-[1px] bg-slate-200"></span> Happy Hours
                                </h3>

                                <div className="flex items-center justify-between p-5 mt-5 rounded-2xl bg-slate-50 border border-slate-100 transition-all hover:bg-slate-100/50">
                                    <div>
                                        <p className="text-sm font-bold text-slate-700">Active Status</p>
                                        <p className="text-xs text-slate-500">Happy Hours Status</p>
                                    </div>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            checked={formData.happy_hours.is_active ?? false}
                                            className="sr-only peer"
                                            onChange={(val) => setFormData((prev) => ({
                                                ...prev,
                                                happy_hours: {
                                                    ...prev.happy_hours,
                                                    is_active: val.target.checked,
                                                },
                                            }))}
                                            disabled={mode === "view"}
                                        />
                                        <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                                    </label>
                                </div>

                                {formData.happy_hours.is_active ?
                                    <>
                                        <div className="mt-5">
                                            <Autocomplete
                                                multiple
                                                id="checkboxes-tags-demos"
                                                value={day}
                                                onChange={(event, newValue) => {
                                                    setDay(newValue);
                                                }}
                                                options={dayOfWeek}
                                                disableCloseOnSelect
                                                getOptionLabel={(option) => option.value}
                                                renderOption={(props, option, { selected }) => {
                                                    const { key, ...optionProps } = props;
                                                    return (
                                                        <li key={key} {...optionProps}>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={checkedIcon}
                                                                style={{ marginRight: 8 }}
                                                                checked={selected}
                                                            />
                                                            {option.key}
                                                        </li>
                                                    );
                                                }}
                                                sx={{ width: '100%' }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Day of week" placeholder="Day of week" sx={{
                                                        '& .MuiInputBase-input::placeholder': {
                                                            fontSize: '10px',  // Your desired font size
                                                            opacity: 0.8,
                                                            color: 'rgba(0,0,0,0.6)',
                                                            borderRadius: '10px'
                                                        }
                                                    }} />
                                                )}
                                                size="small"
                                            />
                                        </div>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 mt-5">
                                            <TimePickerField
                                                label="Start Time"
                                                mode={mode === "view" ? "view" : "edit"}
                                                value={formData.happy_hours.start_time}
                                                onChange={(val) => setFormData((prev) => ({
                                                    ...prev,
                                                    happy_hours: {
                                                        ...prev.happy_hours,
                                                        start_time: val,
                                                    },
                                                }))}
                                            />

                                            <TimePickerField
                                                label="End Time"
                                                mode={mode === "view" ? "view" : "edit"}
                                                value={formData.happy_hours.end_time}
                                                onChange={(val) => setFormData((prev) => ({
                                                    ...prev,
                                                    happy_hours: {
                                                        ...prev.happy_hours,
                                                        end_time: val,
                                                    },
                                                }))}
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <FormInput
                                                label="Offer Price"
                                                value={formData.happy_hours.override_price}
                                                onChange={(val) => setFormData((prev) => ({
                                                    ...prev,
                                                    happy_hours: {
                                                        ...prev.happy_hours,
                                                        override_price: val,
                                                    },
                                                }))}
                                                placeholder="Offer Price"
                                                disabled={mode === "view"}
                                                error={errors.advance_amount}
                                            />
                                        </div>
                                    </>
                                    : ""}
                            </div>
                            <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
                                <button
                                    onClick={closeModal}
                                    className="px-6 py-2.5 rounded-xl text-sm font-bold text-slate-500 hover:bg-slate-100 transition-colors"
                                >
                                    Discard
                                </button>

                                {mode !== "view" && (
                                    <button
                                        onClick={updatePackages}
                                        className="px-8 py-2.5 rounded-xl bg-[#72398E] text-white text-sm font-bold shadow-lg shadow-slate-200 hover:bg-purple-600 transition-all active:scale-95"
                                    >
                                        {mode === "edit" ? "Save Changes" : "Save"}
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal>
                </>
            }
        </>
    )
}

function FormInput({
    label,
    value,
    onChange,
    placeholder,
    readOnly,
    disabled,
    type = "text",
    error
}) {
    return (
        <div className="flex flex-col">
            <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
                {label}
            </label>
            <input
                type={type}
                placeholder={placeholder}
                value={value || ""}
                readOnly={readOnly}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none 
            ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
            ${(readOnly || disabled)
                        ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
                        : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
          `}
            />
            {error && (
                <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
                    {error}
                </span>
            )}
        </div>
    );
}

function FormTextareaInput({
    label,
    value,
    onChange,
    placeholder,
    readOnly,
    disabled,
    type = "text",
    error
}) {
    return (
        <div className="flex flex-col">
            <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
                {label}
            </label>
            <textarea
                type={type}
                placeholder={placeholder}
                value={value || ""}
                readOnly={readOnly}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none h-48
            ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
            ${(readOnly || disabled)
                        ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
                        : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
          `}
            />
            {error && (
                <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
                    {error}
                </span>
            )}
        </div>
    );
}


export default Packages